import { useTranslate } from '@c3po/i18n'
import Button from '@kawaui/button'
import IconDisconnection from '@kawaui/icons/build/icons/action/Disconnection'
import { useAuth } from '@narf/auth'

import { redirectToLogoutPage } from 'utils/methods'

import * as Styled from './styles'

const LoggedInFooter = () => {
  const { i18n } = useTranslate()
  const member = useAuth()

  if (!member) return null

  return (
    <Button variant="tertiary" isFullWidth onClick={redirectToLogoutPage} role="button" aria-label={i18n('logout-button.title')}>
      <Styled.LogoutButtonContent>
        <IconDisconnection width={20} height={21} />
        {i18n('logout-button.title')}
      </Styled.LogoutButtonContent>
    </Button>
  )
}

export default LoggedInFooter
